import React, { useState,useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useNotification} from 'config/Notification';

import { loginAPIService} from 'services/modules/idp/auth';

import {setErrors} from 'stores/modules/idp/authreducer';
import { setAuthenticatedRoleStatus, setCompanyData } from 'stores/modules/idp/authreducer';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


function Login() {
  // State  variables
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [users, setUsers] = useState({});
  const [usernameError, setUsernameError] = useState('');

  // Redux selectors
  const promptNewPasswordStatusContainer = useSelector(state => state.auth.promptNewPasswordStatus);
  const authenticationStatusContainer = useSelector(state => state.auth.authenticationStatus);
  const authenticatedUserContainer = useSelector(state => state.auth.user);
  const getErrorsContainer = useSelector(state => state.auth.errors);
  
  // React Router
  const Navigate = useNavigate();

  // Redux dispatch
  const dispatch = useDispatch();

  // Notification 
  const { openNotification } = useNotification();

  // Handles changes to the username and password fields
  const handleChange = (e) => {
    const { name , value} = e.target;
    setUsers({ ...users, [e.target.name]: e.target.value });
    switch(name) {
      case 'username':
        setUsernameError(value.trim() === '' ? 'username is required' : '');
        break;
      case 'password':
        setPasswordError(value.trim() === '' ? 'password is required' : '');
        break;
     
      default:
        break;
    }
  };

  // Handles form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowPassword(false);
    if (!users.username) {
      setUsernameError('username is required');
    } 
    else {
      setUsernameError('');
    }
  
    if (!users.password) {
      setPasswordError('password is required');
    } 
    else {
      setPasswordError('');
    }
    setLoading(true); 
   
  
    try {
      if (users.username && users.password) {
        await dispatch(loginAPIService(users));
      }
    } catch (error) {
        openNotification('Invalid data','error')
    } finally {
        setLoading(false);
      
    }
  };

  // Handles forgot password link click
  const handleClick = () => {
    dispatch(setErrors(null));
    Navigate('/Request-Forgot-Password')
  }
  

  // useEffect hook to handle authentication and redirection
  useEffect(() => {
     
    if (authenticationStatusContainer === true) {
      
      if (authenticatedUserContainer){
        if (!authenticatedUserContainer.roles[0].permissions.includes('GET_ALL_USERS')){
          dispatch(setAuthenticatedRoleStatus(true));
        }
        if (authenticatedUserContainer.company){
          const companyData = {
            companyid: authenticatedUserContainer.company.id,
            companyname:authenticatedUserContainer.company.name,
            domain:authenticatedUserContainer.company.domain,
            partnercustomer: (authenticatedUserContainer.company.customers.length>0)? true:false,
            soc_group: authenticatedUserContainer?.company?.soc_group,
            soc_env: authenticatedUserContainer?.company?.soc_env
          };
          dispatch(setCompanyData(companyData));
        }
      }
      if (authenticatedUserContainer && authenticatedUserContainer.roles && !!authenticatedUserContainer.roles.find((role) =>  role.permissions.includes("VIEW_ALL_COMPANIES"))) {
        Navigate("/companies")
      } 
      else if (authenticatedUserContainer && authenticatedUserContainer.roles && !!authenticatedUserContainer.roles.find((role) => role.permissions.includes("VIEW_COMPANY_SUB_COMPANIES")) &&
      authenticatedUserContainer.company_id.subscription_plan.name.includes("PARTNER")) 
        {
          if(authenticatedUserContainer.company.applications.length>1){
            let cap =false;
            let ecs= false;
            let rs=false;
            let soc=false;

            authenticatedUserContainer.company.applications.forEach((app) => {
              if(app.slug==="cap") {
                cap=true
              }
              else if(app.slug==="crs"){
                ecs=true;
              }
              else if(app.slug==="soc"){
                soc=true;
              }
              else if(app.slug==="rhymscan"){
                rs=true;
              }
              else if(app.slug==="soc"){
                soc=true;  
              }
            });
            if(cap===true && ecs===true){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate("/integrated-dashboard");
              }else{
                Navigate("/companies")
              }
            }
            else if(ecs===true){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate("/crs/dashboard/over-all");
              }else{
                Navigate("/companies")
              }
            }
            else if(cap===true){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate("/cap/dashboard");
              }else{
                Navigate("/companies")
              }
            }
            else if(rs===true){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate("/rs/dashboard/over-all");
              }else{
                Navigate("/companies")
              }
            }
            else if(soc===true){
              Navigate("/soc/view-agents")
            }
          }
          else {
            let url=authenticatedUserContainer.company.applications[0].slug;
            if(url==="rhymscan"){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate("/rs/dashboard/over-all");
              }else{
                Navigate("/companies")
              }
            }
            else if(url==="crs"){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate("/crs/dashboard/over-all");
              }else{
                Navigate("/companies")
              }
            }
            else if(url==="cap"){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate("/cap/dashboard");
              }else{
                Navigate("/companies")
              }
            }
            else if(url==="crq"){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate("/crq/dashboard");
              }else{
                Navigate("/companies")
              }
            }
            else if(url==="vapt"){
              if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
                Navigate(`/vapt/dashboard/overall`);
              }else{
                Navigate("/companies")
              }
            }
            else if(url==="soc"){  
              Navigate("/companies")
            }
          }
      } 
      else {
        if(authenticatedUserContainer.company.applications.length>1){
          let cap =false;
          let ecs= false;
          let rs=false;
          let soc=false;
          authenticatedUserContainer.company.applications.forEach((app) => {
            if(app.slug==="cap") {
              cap=true
            }
            else if(app.slug==="crs"){
              ecs=true;
            }
            else if(app.slug==="rhymscan"){
              rs=true;
            }
            else if(app.slug==="soc"){
              soc=true;          
            }
          });
          if(cap===true && ecs===true){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate("/integrated-dashboard");
            }
            else{
                  Navigate("/companies")
            }
          }
          else if(ecs===true){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate("/crs/dashboard/over-all");
            }else{
              Navigate("/companies")
            }
          }
          else if(cap===true){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate("/cap/dashboard");
            }
            else{
              Navigate("/companies")
            }
          }
          else if(rs===true){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate("/rs/dashboard/over-all");
            }
            else{
              Navigate("/companies")
            }
          }
          else if(soc===true){
            Navigate("/soc/view-agents")
          }
        } 
        else {
          let url=authenticatedUserContainer.company.applications[0].slug;
          if(url==="rhymscan"){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate("/rs/dashboard/over-all");
            }
            else{
              Navigate("/companies")
            }
          }
          else if(url==="crs"){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate("/crs/dashboard/over-all");
            }
            else{
              Navigate("/companies")
            }
          }
          else if(url==="cap"){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate("/cap/dashboard");
            }
            else{
              Navigate("/companies")
            }
          }
          else if(url==="crq"){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate("/crq/dashboard");
            }
            else{
              Navigate("/companies")
            }
          }
          else if(url==="vapt"){
            if(authenticatedUserContainer.roles[0].slug==="user" || authenticatedUserContainer.roles[0].slug==="admin" || authenticatedUserContainer.roles[0].slug==="superuser"){
              Navigate(`/vapt/dashboard/overall`);
            }
            else{
              Navigate("/companies")
            }
          }
          else if(url==="soc"){
            Navigate("/companies")
          }
        }
      }
    }
    else if (authenticationStatusContainer === false && promptNewPasswordStatusContainer) {
      Navigate(`/new-password-confirmation?session=${promptNewPasswordStatusContainer}`)
    }

      // Inside useEffect:
    if (getErrorsContainer && getErrorsContainer.data) {
      const error = getErrorsContainer.data.message;
      openNotification(error, 'error');
      setTimeout(() => {
        dispatch(setErrors(null));
      }, 5); 
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticationStatusContainer, promptNewPasswordStatusContainer,getErrorsContainer])
    
  return (
    <div className='bg-Container'>
      <div className='col-xl-8 col-lg-8 col-md-8 col-sm-10 col-xs-12'>
        <div className="Card">
          <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src="../assets/rhymtech_logo_2.png" alt="RhymLogo" className='Rhym-logo' />
            <div className="heading-container">
              <h1 className='headingtext-login'>RHYM Security Platform</h1>
            </div>
            <img src="../assets/6538623.5a47e6cc.jpg" alt="text" className="bg-logo" />
          </div>
          <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <div className='Card-Container'>
              <div className='form-card'>
                <img src="../assets/loginuser.svg" alt="UserIcon" className="user-icon" />
                <h3 className="pageHeading m-3">Login to your account</h3>
                <form onSubmit={handleSubmit}>
                  <OutlinedInput
                    className= {usernameError ? 'err-label' :'noerr-label'}
                    type="text"
                    name="username"
                    onChange={handleChange}
                    onBlur={() => setUsernameError(!users.username ? 'username is required' : '')}
                    error={Boolean(usernameError)}
                    placeholder={usernameError ? 'Username is required' : 'Username'}
                    endAdornment={usernameError && (
                      <InputAdornment position="end">
                        <ErrorOutlineIcon className='erroutline-icon' />
                      </InputAdornment>
                    )}
                  />
                  <OutlinedInput
                    className={passwordError ? 'err-label' : 'noerr-label'}
                    name="password"
                    onChange={handleChange}
                    placeholder={passwordError ? "Password is required" : "Password"}
                    type={showPassword ? 'text' : 'password'}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton  onClick={() => setShowPassword((show) => !show)} edge="end">
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                        {passwordError && ( <ErrorOutlineIcon className='erroutline-icon' /> )}
                      </InputAdornment>
                    }
                    onBlur={() => setPasswordError(!users.password ? 'Password is required' : '')}
                    error={passwordError}
                  />
                  <Button className="submit-button" type="submit" variant="contained" > Sign In </Button>
                  {loading && <div className="loader-overlay"> <CircularProgress size={80} className="circular-progress" /> </div>}
                  <a onClick={handleClick} href className='forgottext'>Forgot Password</a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default Login;